import { render, staticRenderFns } from "./createPoint.vue?vue&type=template&id=c4764d86&"
import script from "./createPoint.vue?vue&type=script&lang=js&"
export * from "./createPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports